/* NYRI — Rychlý nákup na kartách produktů (homepage)
   Tlačítko „Do košíku" přidá 1 měsíční balení (jednorázový nákup)
   a vysune košík. Klik jinam na kartu vede dál na detail produktu.
   Akce 2+1 i ostatní logika košíku běží jako dřív (hlídá je nyri-kosik.js). */
(function () {
  'use strict';
  if (window.__NYRI_RYCHLY__) return;
  window.__NYRI_RYCHLY__ = true;

  var TEXT = 'Do košíku';
  var HOTOVO = 'Přidáno';
  var IKONA = '<svg class="nyri-rn-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var FAJFKA = '<svg class="nyri-rn-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function handleZ(karta) {
    var m = (karta.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  /* 1 měsíční balení, jinak první dostupná varianta */
  function vyberVariantu(p) {
    var v = p.variants || [], i;
    for (i = 0; i < v.length; i++) {
      if (v[i].available && /^\s*1\s*m/i.test(v[i].title || '')) return v[i];
    }
    for (i = 0; i < v.length; i++) {
      if (v[i].available) return v[i];
    }
    return null;
  }
  function obsah(btn, ikona, text) {
    btn.innerHTML = ikona + '<span class="nyri-rn-t">' + text + '</span>';
  }
  function hotovo(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    obsah(btn, FAJFKA, HOTOVO);
    setTimeout(function () {
      btn.classList.remove('is-added');
      obsah(btn, IKONA, TEXT);
      delete btn.dataset.nyriBusy;
    }, 1800);
  }

  /* RYCHLE: produkt se načte jen jednou a dopředu, košík vyjede hned po kliknutí */
  var produkty = {};
  function nactiProdukt(handle) {
    if (!produkty[handle]) {
      produkty[handle] = fetch(root() + 'products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('produkt'); return r.json(); })
        .catch(function (e) { delete produkty[handle]; throw e; });
    }
    return produkty[handle];
  }
  function kosikHned(kosik, btn) {
    if (!kosik || !kosik.open || !kosik.renderContents) return;
    kosik.classList.add('nyri-nacita');
    try { kosik.open(btn); } catch (e) {}
  }
  function kosikHotovo(kosik) {
    if (kosik) kosik.classList.remove('nyri-nacita');
  }

  function pridej(btn, karta) {
    if (btn.dataset.nyriBusy) return;
    var handle = handleZ(karta);
    if (!handle) { location.href = karta.href; return; }

    btn.dataset.nyriBusy = '1';
    btn.classList.add('is-loading');
    var kosik = document.querySelector('cart-drawer');
    var varianta = null;

    kosikHned(kosik, btn);
    nactiProdukt(handle)
      .then(function (p) {
        varianta = vyberVariantu(p);
        if (!varianta) throw new Error('neni skladem');
        var telo = { id: varianta.id, quantity: 1 };
        if (kosik && kosik.getSectionsToRender) {
          telo.sections = kosik.getSectionsToRender().map(function (s) { return s.id; });
          telo.sections_url = location.pathname;
        }
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(telo)
        });
      })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw j;
          return j;
        });
      })
      .then(function (j) {
        hotovo(btn);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nyri-rychly-nakup', productVariantId: varianta.id, cartData: j });
        }
        if (kosik && kosik.renderContents && j.sections) {
          kosik.classList.remove('is-empty');
          kosik.renderContents(j);
          kosikHotovo(kosik);
        } else if (window.nyriObnovKosik) {
          window.nyriObnovKosik().then(function () { kosikHotovo(kosik); });
          if (kosik && kosik.open) kosik.open();
        } else {
          location.href = root() + 'cart';
        }
      })
      .catch(function () {
        /* když se něco pokazí, pošle zákaznici na detail produktu */
        kosikHotovo(kosik);
        if (kosik && kosik.close) kosik.close();
        location.href = karta.href;
      });
  }

  /* RYCHLE: produkt z homepage se načte dopředu, až je karta skoro na obrazovce */
  var hlidac = ('IntersectionObserver' in window) ? new IntersectionObserver(function (zaznamy) {
    zaznamy.forEach(function (z) {
      if (!z.isIntersecting) return;
      hlidac.unobserve(z.target);
      var h = handleZ(z.target);
      if (h) nactiProdukt(h).catch(function () {});
    });
  }, { rootMargin: '300px' }) : null;

  function init() {
    document.querySelectorAll('a.product-card .product-button:not([data-nyri-rn])').forEach(function (btn) {
      var karta = btn.closest('a.product-card');
      if (!karta) return;
      var nazev = (karta.querySelector('.product-title') || {}).textContent || 'produkt';
      btn.setAttribute('data-nyri-rn', '');
      if (hlidac) hlidac.observe(karta);
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-label', 'Přidat ' + nazev.trim() + ' do košíku');
      obsah(btn, IKONA, TEXT);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        pridej(btn, karta);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          pridej(btn, karta);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1000);

  /* Stránka Akce 2+1: stejné tlačítko „Do košíku" pod každým produktem v seznamu */
  function akceKarty() {
    if (location.pathname.indexOf('/collections/akce-2-1') !== 0) return;
    document.querySelectorAll('.card-wrapper:not([data-nyri-rn])').forEach(function (w) {
      var odkaz = w.querySelector('a[href*="/products/"]');
      var cena = w.querySelector('.card__information .price');
      var info = cena ? cena.closest('.card__information') : null;
      if (!odkaz || !info) return;
      w.setAttribute('data-nyri-rn', '');
      var btn = document.createElement('span');
      btn.className = 'product-button nyri-rn-akce';
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-label', 'Přidat ' + (odkaz.textContent || 'produkt').trim() + ' do košíku');
      obsah(btn, IKONA, TEXT);
      info.appendChild(btn);
      /* RYCHLE: produkt se načte dopředu + cena měsíčního balení místo „Od …" */
      var h = handleZ(odkaz);
      if (h) {
        nactiProdukt(h)
          .then(function (p) {
            var v = vyberVariantu(p);
            var c = w.querySelector('.card__information .price-item--regular');
            if (v && c) c.textContent = Math.round(v.price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0Kč';
            w.classList.add('nyri-rn-cena');
          })
          .catch(function () { w.classList.add('nyri-rn-cena'); });
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        pridej(btn, odkaz);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          pridej(btn, odkaz);
        }
      });
    });
  }
  function akceSpust() {
    akceKarty();
    /* po filtrování nebo řazení Shopify seznam překreslí, tlačítka se doplní znovu */
    var g = document.getElementById('ProductGridContainer');
    if (g && !g.__nyriRn && 'MutationObserver' in window) {
      g.__nyriRn = true;
      new MutationObserver(akceKarty).observe(g, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', akceSpust);
  } else {
    akceSpust();
  }
  setTimeout(akceKarty, 1000);
})();

/* NYRI — jiskry při kliknutí na potvrzovací tlačítka (PC i mobil) */
(function () {
  'use strict';
  if (window.__NYRI_JISKRY__) return;
  window.__NYRI_JISKRY__ = true;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = '.nyri-btn, .cart__checkout-button, .hero-tlacitko-cervene, .ade-bundles__btn, ' +
            '.nsb__btn, .nyri-cf-btn, .nyri-aff__btn, .nyri-blog-btn, .nyri-nl-btn, .product-button, .nyri-hot-cta';

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn || btn.disabled || btn.hasAttribute('disabled')) return;

    var r = btn.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2, pocet = 8;

    for (var i = 0; i < pocet; i++) {
      var s = document.createElement('span');
      s.className = 'nyri-jiskra' + (i % 2 ? ' pk' : '');
      var uhel = (Math.PI * 2 / pocet) * i + Math.random() * 0.5;
      var dal = 38 + Math.random() * 22;
      s.style.left = cx + 'px';
      s.style.top = cy + 'px';
      s.style.setProperty('--x', (Math.cos(uhel) * (r.width / 2 + dal * 0.6)).toFixed(1) + 'px');
      s.style.setProperty('--y', (Math.sin(uhel) * (r.height / 2 + dal * 0.5)).toFixed(1) + 'px');
      document.body.appendChild(s);
      setTimeout(function (x) { return function () { x.remove(); }; }(s), 750);
    }
  }, { passive: true });
})();